import FlightModalCard from './FlightModalCard';

export default FlightModalCard;
